import moment from 'moment';

export const DATETIME_API_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const convertApiDate = (targetDate: moment.Moment) => {
    return targetDate.format(DATETIME_API_FORMAT);
};
